import React from 'react';

import { makeStyles, TableRow, TableCell } from '@material-ui/core';

const useStyles = makeStyles({
    iconEstado: {
        '&:hover': {
            backgroundColor: '#80808026',
        },
    },
});

const optionsfecha = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
};

export const VacunasItem = (props) => {

    const classes = useStyles();

    const { vacuna } = props;
    return (
        <>
            <TableRow className={classes.iconEstado}>
                <TableCell>
                    {vacuna?.profesional === '' ? 'No Registrado' : vacuna.profesional}
                </TableCell>
                <TableCell>
                    {vacuna?.establecimiento === '' ? 'No Registrado' : vacuna.establecimiento}
                </TableCell>
                <TableCell>
                    {new Date(vacuna?.fechaAplicacion).toLocaleString('es', optionsfecha)}
                </TableCell>
                <TableCell>
                    {vacuna?.vacuna === '' ? 'No Registrado' : vacuna.vacuna}
                </TableCell>
                <TableCell>
                    {vacuna?.lote === ''
                        ? 'No Registrado'
                        : vacuna.lote}
                </TableCell>
                <TableCell>
                    {vacuna?.esquema === ''
                        ? 'No Registrado'
                        : vacuna.esquema}
                </TableCell>
                <TableCell>
                    {vacuna?.dosis === ''
                        ? 'No Registrado'
                        : vacuna.dosis}
                </TableCell>
                <TableCell>
                    {vacuna?.comentario === ''
                        ? 'No Registrado'
                        : vacuna.comentario}
                </TableCell>
            </TableRow>
        </>
    )
}
